<template>
  <div
    v-if="
      cardUpsellItems.length ||
      Object.keys(getListUpsellItems(product?.selectedVariant?.upSell)).length >
        0
    "
    class="upsell-wrap"
    :id="getUpsellId()"
  >
    <div v-if="type == 'card'">
      <div class="pr0 upsell-holder" v-if="cardUpsellItems.length > 0">
        <div class="cross-sell-main pr0">
          <!-- <div class="order-filters-wrap" v-if="cardUpsellItems.length > 1">
            <div
              class="order-filters flex-row align-items-start align-item-center"
            >
              <div
                v-for="(item, index) in cardUpsellItems"
                :key="index"
                :class="filterClasses[item.categoryId]"
                @click="applyFilter(item, $event, index)"
                :dependentComputedProps="{
                  appliedFilters,
                }"
              >
                {{ item.categoryLabel }}
              </div>
            </div>
          </div> -->
          <div class="d-flex h-scroll mt12">
            <mini-product-card
              :card-item="item"
              v-for="(item, index) in upsellItems"
              :key="index"
              :sku-id="item.skuId"
              :data-item-index="index"
              :total-items="totalItems"
            ></mini-product-card>
          </div>
        </div>
      </div>
      <div
        class="pr0 upsell-holder"
        v-if="
          Object.keys(getListUpsellItems(product?.selectedVariant?.upSell))
            .length > 0
        "
      >
        <div class="cross-sell-main pr0">
          <div class="d-flex h-scroll mt12">
            <mini-product-card
              v-for="(item, key, index) in getListUpsellItems(
                product?.selectedVariant?.upSell
              )"
              :card-item="item"
              :sku-id="key"
              :key="index"
              :data-item-index="index"
            ></mini-product-card>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        type == 'list' &&
        Object.keys(getListUpsellItems(product?.selectedVariant?.upSell))
          .length > 0
      "
      class="upsell-list"
    >
      <div class="arrow-up"></div>
      <div class="list-box">
        <div class="color-white fs-16 lh22 bold ml3 mb7">You may also like</div>
        <div class="d-flex h-scroll">
          <div
            v-for="(item, key, index) in getListUpsellItems(
              product?.selectedVariant?.upSell
            )"
            :key="index"
            class="upsell-list-item mr8"
          >
            <span class="d-flex"
              ><i :class="[item.isVeg ? 'tag-veg' : 'tag-non-veg']" class="mt3">
              </i>
              <span class="fs-12 lh18 color-slaty-dark ml8">{{
                item?.selectedVariant?.displayName
              }}</span>
              <span class="price"
                >+<i class="rs ml5">Rs.</i
                >{{ item?.selectedVariant?.price?.currentPrice }}</span
              >
              <div class="checkbox-wrapper ml10">
                <label class="checkbox">
                  <input
                    type="checkbox"
                    :name="'upsell-lsit-checkbox'"
                    :value="key"
                    :checked="this.selectedListUpSellItems[key]"
                    @change="handleListUpsellItemClick"
                  />
                  <i><span></span></i>
                </label>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { keyMapsGetter, keyMapsMutation } from "../helpers/storeKeys";
import MiniProductCard from "./MiniProductCard.vue";
import Utility from "../helpers/utility";
import {
  EVENT_CLICK_UPSELL_ITEM,
  EVENT_IMPRESSION_UPSELL_ITEM,
  EVENT_CROSS_SELL_CART,
} from "../helpers/analyticsEvents";

export default {
  name: "Upsell",
  components: {
    MiniProductCard,
  },
  props: {
    type: { required: false, default: "card" },
    product: { required: false, default: {} },
    parentProductQuantity: { required: false, default: 0 },
  },
  data() {
    return {
      productItem: {},
      impressionProcessed: false,
      previousParentProductQuantity: 0,
      filterClasses: {},
    };
  },
  mounted() {
    EVENT_CROSS_SELL_CART({
      userAction: "Launch",
      noOfCategoriesAvailable: this.cardUpsellItems.length || 0,
      noOfItemsAvailable: this.totalItems || 0,
    });
    if (this.getDistanceFromBottom(this.getUpsellId()) < 200) {
      Utility.scrollUptoTo(this.getUpsellId(), 550);
    }
  },
  updated() {
    if (this.parentProductQuantity > this.previousParentProductQuantity) {
      this.previousParentProductQuantity = this.parentProductQuantity;
    } else if (
      this.parentProductQuantity < this.previousParentProductQuantity
    ) {
      this.previousParentProductQuantity = this.parentProductQuantity;
    }
  },
  methods: {
    getUpsellId() {
      return `upsell-scroll-${this.product?.displayName}`;
    },
    updateDisableItemToastMsg() {
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, false);
    },
    handleListUpsellItemClick(e) {
      let data = { checked: e.currentTarget.checked, value: e.target._value };
      e.currentTarget.checked = false;
      if (data.checked && !this.selectedListUpSellItems[data.value]) {
        EVENT_CLICK_UPSELL_ITEM({
          upsellProductName: this.getListUpsellItems(
            this.product?.selectedVariant?.upSell
          )?.[data.value]?.selectedVariant?.displayName,
        });
        this.addUpSellItemsInCart(data.value);
        this.selectedListUpSellItems[data.value] = data.checked;
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_LIST_UPSELL_ITEMS,
          this.selectedListUpSellItems
        );
      } else {
        this.removeUpSellItemsInCart(data.value);
        this.selectedListUpSellItems[data.value] = data.checked;
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_LIST_UPSELL_ITEMS,
          this.selectedListUpSellItems
        );
      }
    },
    addUpSellItemsInCart(upSellProductUID) {
      this.$store.commit(
        keyMapsMutation.ADD_TO_CART,
        this.getListUpsellItems(this.product?.selectedVariant?.upSell)[
          upSellProductUID
        ]
      );

      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
        "1 Item added to the cart."
      );
      setTimeout(this.updateDisableItemToastMsg, 1000);
    },
    removeUpSellItemsInCart(upSellProductUID) {
      this.$store.commit(
        keyMapsMutation.REMOVE_FROM_CART,
        this.getListUpsellItems(this.product?.selectedVariant?.upSell)[
          upSellProductUID
        ]
      );
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
        "1 Item removed from the cart."
      );
      setTimeout(this.updateDisableItemToastMsg, 1000);
    },
    applyFilter(item, e, index) {
      if (this.appliedFilters === item.categoryId) {
        this.$store.commit(
          keyMapsMutation.UPDATE_APPLIED_UPSELL_FILTER,
          Object.keys(this.filterClasses)[0]
        );
        // EVENT_CLICK_FILTERS({
        //   category: item.categoryLabel,
        //   subCategory: "filter unchecked",
        //   positionWithinSection: index + 1,
        // });
      } else {
        this.$store.commit(
          keyMapsMutation.UPDATE_APPLIED_UPSELL_FILTER,
          item.categoryId
        );
        // EVENT_CLICK_FILTERS({
        //   category: item.categoryLabel,
        //   subCategory: "filter checked",
        //   positionWithinSection: index + 1,
        // });

        EVENT_CROSS_SELL_CART({
          userAction: "Item Category",
          eventCategory: item.categoryLabel,
          categoryPosition: index + 1,
          itemsCountInCategory: this.upsellItems.length,
        });
      }
    },
    getDistanceFromBottom(elementId) {
      var el = document.getElementById(elementId);
      if (!el) {
        console.error(`Element with ID ${elementId} not found.`);
        return;
      }

      var elBottom = el.getBoundingClientRect().bottom;
      var viewportHeight = window.innerHeight;

      return viewportHeight - elBottom;
    },
  },
  computed: {
    cardUpsellItems() {
      let globalUpsellItems =
        this.$store.getters[keyMapsGetter.GET_GLOBAL_UPSELL_ITEMS];

      if (globalUpsellItems.length > 0 && !this.impressionProcessed) {
        this.impressionProcessed = true;
        EVENT_IMPRESSION_UPSELL_ITEM();
      }
      return globalUpsellItems
        .filter((x) => x?.products?.length)
        .sort((y, z) => y.categoryId - z.categoryId);
    },
    upsellItems() {
      return (
        // this.cardUpsellItems.find((x) => this.appliedFilters === x.categoryId)
        //   ?.products ||
        // this.cardUpsellItems.find((x) => x.categoryId === "0")?.products
        this.cardUpsellItems.flatMap((category) => category?.products)
      );
    },
    getListUpsellItems() {
      return (upsell) => {
        let upsells =
          this.$store.getters[keyMapsGetter.GET_UPSELL_PRODUCTS](upsell);
        if (Object.keys(upsells).length > 0 && !this.impressionProcessed) {
          this.impressionProcessed = true;
          EVENT_IMPRESSION_UPSELL_ITEM();
        }
        let filteredUpsells = {};
        Object.keys(upsells)
          .filter((_) => !this.selectedListUpSellItems[_])
          .map((_) => {
            filteredUpsells[_] = upsells[_];
          }); // commenting it as discussed with product we should not remove upsell items even after selection
        return upsells;
      };
    },
    appliedFilters() {
      let appliedFlt =
        this.$store.getters[keyMapsGetter.GET_APPLIED_UPSELL_FILTER];
      this.cardUpsellItems.map((flt) => {
        if (flt.categoryId === appliedFlt) {
          this.filterClasses[flt.categoryId] =
            "order-filter-item flex-row fs-11 lh-18 ml4 selected-filter-item";
        } else {
          this.filterClasses[flt.categoryId] =
            "order-filter-item flex-row fs-11 lh-18 ml4";
        }
      });
      if (!this.cardUpsellItems.find((x) => appliedFlt === x.categoryId)) {
        appliedFlt = Object.keys(this.filterClasses)[0];
        this.filterClasses[appliedFlt] =
          "order-filter-item flex-row fs-11 lh-18 ml4 selected-filter-item";
      }
      return appliedFlt;
    },
    totalItems() {
      let globalUpsellItems =
        this.$store.getters[keyMapsGetter.GET_GLOBAL_UPSELL_ITEMS];
      let total = 0;
      globalUpsellItems.map((items) => {
        total = total + items?.products?.length || 0;
      });
      return total;
    },
    selectedListUpSellItems() {
      return this.$store.state.Cart.selectedListUpSellItems;
    },
  },
};
</script>

<style></style>
